export default __webpack_public_path__ + "1d9254398a252f48e2e31442c02276e7.png";